module.exports = __webpack_public_path__ + "static/outpatient-photo-dfeaa47c561ea4fe6ce6803e10ace6d4.jpg";